/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable no-unused-labels */
import { camelToKebab, log, warn, arrayIncludes } from '@slardar/sdk-template';
import { getDefaultBrowser, loadScript, onPageLoad, getGlobalRegistry, reportSelfError, } from '@slardar/sdk-web';
import { SDK_VERSION } from './constants';
var isDebug = '';
debug: {
    isDebug = 'debug.';
}
export function loadPluginsOnPageLoad(client, registry, lp) {
    if (lp === void 0) { lp = loadPlugins; }
    onPageLoad(function () {
        client.on('init', function () {
            lp(client, registry);
        });
    });
}
export function loadPlugins(client, registry, ld) {
    if (ld === void 0) { ld = loadNow; }
    var _a = client.config(), plugins = _a.plugins, pluginBundle = _a.pluginBundle;
    Object.keys(plugins).forEach(function (name) {
        // check if plugin is enabled, plugins[name]: false means it's disabled
        if (plugins[name]) {
            // check if we have a bundle containing this plugin
            if (pluginBundle && arrayIncludes(pluginBundle.plugins, name)) {
                ld(client, pluginBundle, registry);
            }
            else {
                ld(client, { name: name, config: plugins[name] }, registry);
            }
        }
    });
}
export function loadNow(client, _a, registry, ls) {
    var name = _a.name, plugins = _a.plugins, config = _a.config;
    if (ls === void 0) { ls = loadScript; }
    if (loadingOrLoaded(client, name)) {
        return;
    }
    client.loading.push(name);
    var path = getPluginPath(client, name, config);
    ls(path, function () {
        if (arrayIncludes(client.loaded, name)) {
            return;
        }
        if (plugins) {
            plugins.forEach(function (name) {
                if (!arrayIncludes(client.loaded, name)) {
                    applyPlugin(client, name, registry);
                }
            });
        }
        else {
            applyPlugin(client, name, registry);
        }
    });
}
function loadingOrLoaded(client, name) {
    return arrayIncludes(client.loaded, name) || arrayIncludes(client.loading, name);
}
function getPluginPath(client, name, config) {
    var _a;
    return (_a = config === null || config === void 0 ? void 0 : config.path) !== null && _a !== void 0 ? _a : client.config().pluginPathPrefix + "/" + camelToKebab(name) + "." + SDK_VERSION + "." + isDebug + "js";
}
export function applyPlugin(client, name, registry) {
    if (registry === void 0) { registry = getGlobalRegistry(getDefaultBrowser()); }
    if (!registry)
        return;
    var plugin = getPluginFromRegistry(registry, name);
    if (!plugin) {
        warn('[loader].applyPlugin not found', name);
        return;
    }
    try {
        plugin.apply(client);
        client.loaded.push(name);
    }
    catch (err) {
        reportSelfError(err);
        warn('[loader].applyPlugin failed', name, err);
    }
}
function getPluginFromRegistry(registry, name) {
    return registry.plugins.filter(function (l) { return l.name === name && l.version === SDK_VERSION; })[0];
}
// 注册到指定注册表
export function register(name, apply, registry) {
    if (registry === void 0) { registry = getGlobalRegistry(getDefaultBrowser()); }
    if (!registry || !registry.plugins)
        return;
    if (getPluginFromRegistry(registry, name)) {
        return;
    }
    registry.plugins.push({
        name: name,
        version: SDK_VERSION,
        apply: apply,
    });
}
//# sourceMappingURL=loader.js.map